import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import styles from "./DailyphasingLanding.module.css";
import resetBtn from "../../../../../assets/images/resetBtn.png";
import Filters from "../../../../../assets/images/filters.svg";
import Slider from "../../../../../assets/images/sliders 1.svg";
import Excel from "../../../../../assets/images/Excel.svg";
import { useDailyPhasingContext } from 'utils/dailyphaisngContext/DailyphasingContext';
import { Box, Chip, CircularProgress, ListItem, Tab, Tabs } from '@mui/material';
import MultiSelectWithSearchInput from "../../../../components/dropdown/MultiSelectWithInput";
import CustomiseColumns from 'Samarth Module/components/drawers/CustomiseColumns';
import MoreFilters from 'Samarth Module/components/drawers/moreFilters';
import DPTableView from './DPTableView';
import DPScheduleView from './DPScheduleView';
import styled from "@emotion/styled";
import OverflowMenu from "Samarth Module/components/overflowMenu/OverflowMenu";
import { getDPTableViewDetails, getPlanWeekFilterDetails } from "Samarth Module/api/DailyphaingAPIs";
import { useMsal } from "@azure/msal-react";
import { exportToExcelFile } from "Samarth Module/api/api";
import SnackBarMessage from "Samarth Module/components/snackbar/snackbar";
import { SAPWeeklyPlanColumn, smartProdSchedularInputFields } from "Samarth Module/constants/dailyPhasing";
import { timeBasedFlagDPR } from "utils/mmScreenInput";

const STATIC_FILTER_LABELS = new Set(["Week", "Plan", "UOM"]);

const TalViewTabs = styled(Tabs)({
    "&.MuiTabs-root": { minHeight: "0px" },
    "&.MuiTabs-root .MuiTabs-fixed span": { background: "none" },
});

const TalViewTab = styled(Tab)({
    "&.MuiButtonBase-root": {
        fontSize: "10px",
        fontWeight: 600,
        lineHeight: 1,
        border: "1px solid #949495",
        padding: "8px 12px",
        minHeight: "0px",
        background: "#fff",
        textTransform: "capitalize",
        color: "#333",
    },
    "&.MuiButtonBase-root: first-of-type": {
        borderRadius: "5px 0 0 5px",
    },
    "&.MuiButtonBase-root: last-of-type": {
        borderRadius: "0 5px 5px 0",
    },
    "&.Mui-selected": {
        color: "#fff",
        border: "1px solid #1F36C7",
        background: "#1F36C7",
    },
});

function getISOWeekNumber(date) {
    // Copy date so we don't modify original
    const tmpDate = new Date(date.getTime());

    // Set to nearest Thursday (ISO week date algorithm)
    tmpDate.setHours(0, 0, 0, 0);
    tmpDate.setDate(tmpDate.getDate() + 3 - ((tmpDate.getDay() + 6) % 7));

    // Week 1 is the week with January 4th in it
    const week1 = new Date(tmpDate.getFullYear(), 0, 4);

    // Calculate week number
    return (
        1 +
        Math.round(
            ((tmpDate.getTime() - week1.getTime()) / 86400000 -
                3 +
                ((week1.getDay() + 6) % 7)) /
            7
        )
    );
}

function getLast12WeeksFormatted() {
    const weeks = [];
    const now = new Date();
    
    for (let i = 0; i < 12; i++) {
        // Create a new date for each week by subtracting i weeks (i * 7 days)
        const targetDate = new Date(now);
        targetDate.setDate(now.getDate() - (i * 7));
        
        const week = getISOWeekNumber(targetDate);
        weeks.push(`Week ${week}`);
    }

    return weeks;
}

const initialDropDown = (arr, displayTableViewFilters) => {
    const filters = displayTableViewFilters;
    const updatedFilters = Array.isArray(arr) && arr.length ? filters.map(filter => {
        if (filter.selectedData.length) return filter;
        const updatedData = Array.from(new Set(arr.map(item => item[filter.label]))).sort((a, b) =>
            String(a).localeCompare(String(b))
        );
        return filter.data.length === updatedData.length && filter.data.every((val, i) => val === updatedData[i])
            ? filter
            : { ...filter, data: updatedData };
    }) : [];

    const extraFilters = [{
        "label": "Week",
        "data": getLast12WeeksFormatted(),
        "selectedData": [getLast12WeeksFormatted()[0]],
        "isFavourite": true
    },
    {
        "label": "Plan",
        "data": ['M1', 'S1'],
        // "selectedData": timeBasedFlagDPR(), commented coz business asked to remove M2
        "selectedData": "M1",
        "isFavourite": true,
        "isMultiSelect": false
    },
    {
        "label": "UOM",
        "data": ['Tons', 'Cases'],
        "selectedData": 'Tons',
        "isFavourite": true,
        "isMultiSelect": false
    }
    ];

    return [...extraFilters, ...updatedFilters];
}

const DailyPhasingLanding = ({ type }) => {
    const currentWeek = getLast12WeeksFormatted()[0];
    const { accounts } = useMsal();
    const activeAccount = accounts[0];
    const { tableData, setTableData, filteredTableData, setFilteredTableData } = useDailyPhasingContext();
    const [loader, setLoader] = useState(false);
    const [weekLoader, setWeekLoader] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [tblView, setTblView] = useState(0);
    const [state, setState] = useState({
        defaultTableColumns: [],
        defaultFilterColumns: []
    });
    const [dailyPhasingFilters, setDailyPhasingFilters] = useState([]);
    const [columnList, setColumnList] = useState([]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [filterDrawer, setFilterDrawerOpen] = useState(false);
    const [excelLoading, setExcelLoading] = useState(false);
    const [snackBarObject, setSnackBarObject] = useState({
        snackbarOpen: false,
        message: "",
        type: "error",
    });
    const refColumnsList = useRef(null);
    const latestRequest = useRef(null);
    const firstTimeLoader = useRef(true);
    const skipDataInit = useRef(false);
    const clearFiltersRef = useRef(false);

    const dataInitiaLization = useCallback(async () => {
        try {

            /* data of dailyPhasingFilters */
            const updatedFilters = dailyPhasingFilters.map(filter => {
                if (filter.selectedData.length) return filter;

                const updatedData = tableData.length ? Array.from(new Set(tableData.map(item => item[filter.label]))).sort((a, b) =>
                    String(a).localeCompare(String(b))
                ) : [];

                if (filter.label !== "Week" && filter.label !== "Plan") {
                    return filter.data.length === updatedData.length && filter.data.every((val, i) => val === updatedData[i])
                        ? filter
                        : { ...filter, data: updatedData };
                }
            });
            const keys = Object.keys(tableData[0]);
            let colList = keys.map((key) => {
                if (key.includes(' - ') || key.endsWith('day') || smartProdSchedularInputFields.includes(key)) {
                    return {
                        label: key,
                        sortable: false,
                        key: key,
                        visibility: true
                    }
                }
            }).filter(Boolean);
            setFilteredData((prev) => JSON.stringify(prev) === JSON.stringify(tableData) ? prev : tableData);
            setDailyPhasingFilters((prev) => JSON.stringify(prev) === JSON.stringify(updatedFilters) ? prev : updatedFilters);
            const derivedColList = [...state.defaultTableColumns.filter(col => !(col.label.includes(' - ') || smartProdSchedularInputFields.includes(col.label))), ...colList].filter(
                (item, index, self) =>
                    index === self.findIndex(obj => obj.label === item.label)
            );
            setColumnList(derivedColList);
            refColumnsList.current = derivedColList;
        } catch (err) {
            console.log("Error Message", err.message);
        }
    }, [dailyPhasingFilters, tableData, type]);

    const callHandlePlanWeekFilter = () => {
        const now = new Date();
        const day = now.getDay(); // Sunday=0, Monday=1, ..., Saturday=6
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const totalMinutes = hours * 60 + minutes;

        // Only Saturday after 1 PM OR full Sunday
        return (
            (day === 6 && totalMinutes >= 13 * 60) || // Saturday after 1 PM
            day === 0 // Sunday full day
        );
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (tableData?.length && !skipDataInit.current) {
            dataInitiaLization();
        }
        // Reset the flag after checking
        skipDataInit.current = false;
    }, [dataInitiaLization]);

    const handleError = useCallback((message) => {
        setSnackBarObject({ snackbarOpen: true, message, type: "error" });
    }, []);

    const closeSnackbar = useCallback(() => {
        setSnackBarObject((prev) => ({ ...prev, snackbarOpen: false }));
    }, []);

    // function to fetch filter options
    const fetchFilterOptions = (filtered) => {
        const filterOptions = filtered.reduce((acc, filter) => {
            if (filter.label === 'Week' || filter.label === 'Plan' || filter.label === 'UOM' || filter.selectedData.length === 0) return acc;
            acc[filter.label] = filter.selectedData;
            return acc;
        }, {});
        return filterOptions;
    };

    // api call for fetching data for both DFOS and SAP APO based on the tblView state
    const fetchData = useCallback(async (filtered = []) => {
        const shouldClearFilters = clearFiltersRef.current;
        clearFiltersRef.current = false;
        
        if (firstTimeLoader.current) {
            setLoader(true);
            firstTimeLoader.current = false;
        } else {
            setWeekLoader(true);
        };
        try {
            const selectedFilters = localStorage.getItem('table_view_data') ? JSON.parse(localStorage.getItem('table_view_data')) : [];
            // const dayCondition = callHandlePlanWeekFilter();
            const payload = {
                email: activeAccount.username,
                type: type,
                roles: activeAccount?.idTokenClaims?.roles,
                // Flag: timeBasedFlagDPR(), commented coz business asked to remove M2
                Flag: "M1",
                WeekOfYear: extractWeekOfYear(currentWeek),
                filterData: fetchFilterOptions(filtered),
                CasesOrTonnes : filtered.length ? filtered.find(filter => filter.label === 'UOM')?.selectedData || 'Tons' : selectedFilters.find(filter => filter.label === 'UOM')?.selectedData || 'Tons',
                clearFilters: shouldClearFilters
            }
            const getData = await getDPTableViewDetails(payload);

            if (Object.keys(getData).length && getData["table_view_data"].length) {
                const data = [...getData.table_view_data];
                // if (dayCondition) {
                //     const daysDates = Object.keys(getData['aggregated_data'][0]?.Plan);
                //     const transformedList = getData['aggregated_data'].map(item => {
                //         const result = {};

                //         // Copy all non-Plan/Act/DFOS fields
                //         for (const key in item) {
                //             if (!["Plan", "Act", "DFOS"].includes(key)) {
                //                 result[key] = item[key];
                //             }
                //         }

                //         if (payload.WeekOfYear.length > 1) {
                //             // Merge Plan, Act, DFOS into per-day structure
                //             smartProdSchedularInputFields.forEach(day => {
                //                 result[day] = {
                //                     Plan: item.Plan?.[day] ?? 0,
                //                     Act: item.Act?.[day] ?? 0,
                //                     DFOS: item.DFOS?.[day] ?? 0
                //                 };
                //             });

                //             return result;
                //         } else {
                //             // if only one week is selected, keep the structure as is
                //             daysDates.forEach(day => {
                //                 result[day] = {
                //                     Plan: item.Plan?.[day] ?? 0,
                //                     Act: item.Act?.[day] ?? 0,
                //                     DFOS: item.DFOS?.[day] ?? 0
                //                 };
                //             });
                //             return result;
                //         }
                //     });
                //     setTableData(transformedList);
                //     setFilteredTableData(transformedList);
                // } else {
                    setTableData(data);
                    setFilteredTableData(data);
                // }
                setState({
                    ...state,
                    defaultFilterColumns: [...getData.defaultFilterColumns],
                    defaultTableColumns: [...getData.defaultTableColumns, ...SAPWeeklyPlanColumn]
                });
                setDailyPhasingFilters(() => {
                    if (localStorage.getItem("table_view_data")) {
                        return JSON.parse(localStorage.getItem("table_view_data"));
                    } else {
                        return initialDropDown(data, [...getData.defaultFilterColumns]); // Lazy initialization
                    }
                });
            } else {
                setTableData([]);
                setFilteredTableData([]);
            }
        } catch (err) {
            console.log("Error Message", err.message);
            handleError(err?.message || 'An unexpected error occurred');
        } finally {
            setLoader(false);
            setWeekLoader(false);
        }
    }, [type, tblView]);

    const extractWeekOfYear = (dateString) => {
        let weekMatch;
        if (typeof dateString !== 'object') {
            weekMatch = dateString.match(/Week (\d+)/);
            return parseInt(weekMatch[1], 10);
        } else if (dateString && dateString.length) {
            const selectedWeek = [];
            for (let i = 0; i < dateString.length; i++) {
                selectedWeek.push(parseInt(dateString[i].replace('Week ', ''), 10));
            }
            return selectedWeek;
        }
        return null; // or handle the case where the week is not found
    }

    // function to handle plan past week filter change
    const handlePlanWeekFilterData = async (label, value, filtered = []) => {
        const shouldClearFilters = clearFiltersRef.current;
        clearFiltersRef.current = false;
        
        const requestId = Date.now();        // generate unique id for this call
        latestRequest.current = requestId;
        setWeekLoader(true);
        const selectedFilters = localStorage.getItem('table_view_data') ? JSON.parse(localStorage.getItem('table_view_data')) : [];

        try {
            const payload = {
                email: activeAccount.username,
                WeekOfYear: label === 'Week' ? extractWeekOfYear(value) : extractWeekOfYear(filtered.find(filter => filter.label === 'Week').selectedData),
                Flag: label === 'Plan' ? [value] : [filtered.find(filter => filter.label === 'Plan')?.selectedData] || ['M1'],
                type: type,
                filterData: fetchFilterOptions(filtered),
                CasesOrTonnes : filtered.length ? filtered.find(filter => filter.label === 'UOM')?.selectedData || 'Tons' : selectedFilters.find(filter => filter.label === 'UOM')?.selectedData || 'Tons',
                clearFilters: shouldClearFilters

            };
            const planWeekFilterData = await getPlanWeekFilterDetails(payload);
            if (latestRequest.current === requestId) {
                if (planWeekFilterData['aggregated_data'].length) {
                    const daysDates = Object.keys(planWeekFilterData['aggregated_data'][0]?.Plan);
                    const transformedList = planWeekFilterData['aggregated_data'].map(item => {
                        const result = {};

                        // Copy all non-Plan/Act/DFOS fields
                        for (const key in item) {
                            if (!["Plan", "Act", "DFOS"].includes(key)) {
                                result[key] = item[key];
                            }
                        }

                        if (payload.WeekOfYear.length > 1) {
                            // Merge Plan, Act, DFOS into per-day structure
                            smartProdSchedularInputFields.forEach(day => {
                                result[day] = {
                                    Plan: item.Plan?.[day] ?? 0,
                                    Act: item.Act?.[day] ?? 0,
                                    DFOS: item.DFOS?.[day] ?? 0
                                };
                            });

                            return result;
                        } else {
                            // if only one week is selected, keep the structure as is
                            daysDates.forEach(day => {
                                result[day] = {
                                    Plan: item.Plan?.[day] ?? 0,
                                    Act: item.Act?.[day] ?? 0,
                                    DFOS: item.DFOS?.[day] ?? 0
                                };
                            });
                            return result;
                        }
                    });

                    if (transformedList.length > 0) {
                        const keys = Object.keys(transformedList[0]);
                        let defaultColList = [...refColumnsList.current];

                        let colList = keys.map((key) => {
                            if (smartProdSchedularInputFields.includes(key) || key.includes(' - ')) {
                                return {
                                    label: key,
                                    sortable: smartProdSchedularInputFields.includes(key) || key.includes(' - ') ? false : true,
                                    key: key,
                                    visibility: smartProdSchedularInputFields.includes(key) || key.includes(' - ') ? true : false
                                }
                            }
                        });

                        setColumnList([...planWeekFilterData['defaultTableColumns'],...SAPWeeklyPlanColumn, ...colList].filter(Boolean));

                        const updatedFilteredData = transformedList.filter((item) =>
                            filtered.every((filter) =>
                                filter.selectedData.length && (filter.label !== 'Week' && filter.label !== 'Plan' && filter.label !== 'UOM') ? filter.selectedData.includes(item[filter.label]) : true
                            )
                        );
                        
                        // Set flag to skip dataInitiaLization since we're setting filtered data here
                        skipDataInit.current = true;
                        
                        // Set tableData with full transformed list (not filtered)
                        // This prevents dataInitiaLization from running unnecessary filtering
                        setTableData(transformedList);
                        setFilteredData(updatedFilteredData);
                    } else {
                        setFilteredData([]);
                        setTableData([]);
                    }
                } else {
                    setFilteredData([]);
                    setTableData([]);
                }
            }
        } catch (err) {
            console.log("Error Message", err.message);
        } finally {
            if (latestRequest.current === requestId) {
                setWeekLoader(false);
            }
        }
    };

    // exporting data to excel
    const exportToExcel = useCallback(async (data) => {
        try {
            setExcelLoading(true);
            await exportToExcelFile(data);
        } catch (error) {
            setSnackBarObject({ snackbarOpen: true, message: error.message, type: 'error' })
        } finally {
            setExcelLoading(false);
        }
    }, [])

    // submitting column customization
    // submitting column customization
    const columnCustomization = useCallback((list) => {
        const columnList = [...list].filter(col => !(col.label.includes(' - ') || smartProdSchedularInputFields.includes(col.label) || col.label === 'SAP Weekly Plan'));
        const derived = [...list].filter(col => col.label.includes(' - ') || smartProdSchedularInputFields.includes(col.label) || col.label === 'SAP Weekly Plan');
        changeState('customize', [...columnList, ...derived]);
        setColumnList([...columnList, ...derived]);
        setIsDrawerOpen(prev => !prev);

        const weekFilterValues = dailyPhasingFilters.find(filter => filter.label === "Week")?.selectedData || [];
        const shouldCallAggregateAPI = weekFilterValues.length > 1 || checkWeekValue(dailyPhasingFilters);

        if (shouldCallAggregateAPI) {
            handlePlanWeekFilterData("Week", weekFilterValues, dailyPhasingFilters);
        } else {
            fetchData(dailyPhasingFilters);
        }
    }, [dailyPhasingFilters]);

    // handling customise drawer
    const handleCustomizeDrawer = useCallback(() => {
        setIsDrawerOpen(prev => !prev);
    }, []);

    // handling filter drawer
    const handleFilterDrawer = useCallback(() => {
        setFilterDrawerOpen(prev => !prev);
    }, []);


    // checking plan filter value
    const checkPlanValue = (filtered) => {
        const planFilter = filtered.find(filter => filter.label === "Plan");
        if (!planFilter) return false;
        // return planFilter.selectedData !== timeBasedFlagDPR(); commented coz business asked to remove M2
            return planFilter.selectedData !== "M1";
        }

    // checking week filter value
    const checkWeekValue = (filtered) => {
        const weekFilter = filtered.find(filter => filter.label === "Week");
        if (!weekFilter) return false;
        return !weekFilter.selectedData.includes(getLast12WeeksFormatted()[0]) || weekFilter.selectedData.length > 1;
    }

    // Get flag value based on day condition
    // const getFlagValueinFetchData = (dayCondition) => {
    //     return dayCondition ? [timeBasedFlagDPR()] : timeBasedFlagDPR();
    // }

    // handle filter change
    const handleMultiSelectChange = useCallback((label, values) => {
        let filtered;
        setDailyPhasingFilters(prevFilters => {
            filtered = prevFilters.map(filter =>
                filter.label === label ? { ...filter, selectedData: values } : filter
            )
            return filtered;
        });
        
        // Default filters should not prevent clearing the last selected data filter.
        const hasActiveDynamicFilter = filtered.some((filter) => {
            if (STATIC_FILTER_LABELS.has(filter.label)) return false;
            const selected = filter?.selectedData;
            if (Array.isArray(selected)) return selected.length > 0;
            if (typeof selected === 'string') return selected.trim().length > 0;
            return selected !== undefined && selected !== null;
        });
        
        clearFiltersRef.current = !hasActiveDynamicFilter;
        
        if (checkWeekValue(filtered) || checkPlanValue(filtered)) {
            handlePlanWeekFilterData(label, values, filtered);
        } else {
            fetchData(filtered);
        }

        if (label !== "Week") {
            localStorage.setItem('table_view_data', JSON.stringify(filtered));
        }
    }, [dailyPhasingFilters, fetchData, handlePlanWeekFilterData, checkPlanValue]);


    //reset filters
    const resetFilter = useCallback(() => {
        clearFiltersRef.current = true;
        
        localStorage.removeItem('table_view_data');
        console.log('tableData', initialDropDown([...tableData], state.defaultFilterColumns));
        setDailyPhasingFilters(initialDropDown([...tableData], state.defaultFilterColumns))
        fetchData();
    }, [state]);

    // calling export to excel
    const handleExportToExcel = () => {
        exportToExcel(filteredData);
    }

    // change state for filters and customize
    const changeState = (type, desiredList) => {
        setState(prev => ({
            "defaultFilterColumns": type === 'filters' ? [...desiredList] : [...prev.defaultFilterColumns],
            "defaultTableColumns": type === 'customize' ? [...desiredList] : [...prev.defaultTableColumns]
        }))
    };

    // handle table view change SAP APO or DFOS
    const handleDPViewChange = useCallback((e, value) => {
        setTblView(value);
    }, []);

    return (
        <>
            <div className={`${styles.container} ${excelLoading ? styles.blurBackground : ''}`}>
                <div className={styles.dataCard}>
                    {loader ? (
                        <div className={styles.loaderContainer}><CircularProgress /></div>
                    ) : (
                        <Fragment>
                            {/* table filter*/}
                            <div className={styles.filters}>
                                {Array.isArray(dailyPhasingFilters) && dailyPhasingFilters.length > 0 && dailyPhasingFilters.filter((filter) => filter.isFavourite).map((filter) => {
                                    // Get default value for Week, Plan, and UOM filters
                                    let defaultValue = null;
                                    if (filter.label === 'Week') {
                                        defaultValue = [getLast12WeeksFormatted()[0]];
                                    } else if (filter.label === 'Plan') {
                                        // defaultValue = timeBasedFlagDPR(); commented coz business asked to remove M2
                                        defaultValue = 'M1'
                                    } else if (filter.label === 'UOM') {
                                        defaultValue = 'Tons';
                                    }
                                    
                                    return (
                                        <ListItem key={filter.label} className={styles.listCustomClass}>
                                            <MultiSelectWithSearchInput
                                                key={filter.label}
                                                label={filter.label}
                                                options={filter.data}
                                                filterValues={filter.selectedData}
                                                handleFilter={(label, values) => handleMultiSelectChange(label, values)}
                                                disabled={false}
                                                isMultiSelect={filter.isMultiSelect}
                                                type="Daily Phasing"
                                                defaultValue={defaultValue}
                                            />
                                        </ListItem>
                                    );
                                })}
                                {/* reset filter button and three dots menu button */}
                                <div style={{ paddingLeft: '5px', display: 'flex', alignItems: 'center' }}>
                                    <img src={resetBtn} onClick={resetFilter} alt="Reset Filters" style={{ cursor: 'pointer' }} />
                                    <OverflowMenu
                                        menuItems={[
                                            {
                                                label: 'More Filters',
                                                icon: Filters,
                                                onClick: handleFilterDrawer,
                                            },
                                            {
                                                label: 'Customise',
                                                icon: Slider,
                                                onClick: handleCustomizeDrawer,
                                            },
                                            {
                                                label: 'Export',
                                                icon: Excel,
                                                onClick: handleExportToExcel,
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                            <div className={styles.chipsBtnContainer}>
                                {/* filter chip */}
                                <Box className={styles.chipContainer}>
                                    {Array.isArray(dailyPhasingFilters) && dailyPhasingFilters.length > 0 && dailyPhasingFilters.filter((filter) => !filter.isFavourite).map((filter, index) => (
                                        <div key={`${index}_${filter.label}`}>
                                            {filter.selectedData.map((selectedValue, subIndex) => (
                                                <Chip
                                                    key={`${index}-${subIndex}`}
                                                    label={selectedValue}
                                                    onDelete={() => {
                                                        const updatedFilters = [...dailyPhasingFilters].map((f) =>
                                                            f.label === filter.label
                                                                ? { ...f, selectedData: f.selectedData.filter((_, i) => i !== subIndex), }
                                                                : f
                                                        );
                                                        setDailyPhasingFilters(updatedFilters);
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    ))}
                                </Box>
                                {/* view buttons */}
                                <div className={styles.viewBtns}>
                                    <TalViewTabs value={tblView} onChange={handleDPViewChange} aria-label="table tabs">
                                        <TalViewTab label="SAP" />
                                        <TalViewTab label="DFOS" />
                                    </TalViewTabs>
                                </div>
                            </div>

                            {/* table ui starts */}
                            {weekLoader ?
                                <div className={styles.loaderContainer}><CircularProgress /></div>
                                : <div>
                                    {tblView === 0 ?
                                        (
                                            <DPTableView
                                                tableData={filteredData || []}
                                                columns={columnList}
                                                view="SAP"
                                            />
                                        ) :
                                        (
                                            <DPTableView
                                                tableData={filteredData || []}
                                                columns={columnList}
                                                view="DFOS"
                                            />
                                            // <DPScheduleView
                                            //     tableData={filteredData || []}
                                            //     columns={columnList}
                                            // />
                                        )}
                                </div>}
                            {/* customise drawer */}
                            {isDrawerOpen &&
                                <CustomiseColumns
                                    anchor={'right'}
                                    columns={[...columnList]}
                                    isOpen={isDrawerOpen}
                                    handleCustomizeDrawer={handleCustomizeDrawer}
                                    columnCustomization={(customizedColumns) => columnCustomization(customizedColumns)}
                                    username={activeAccount.username}
                                    type="Daily Phasing"
                                />
                            }
                            {/* more filter */}
                            {filterDrawer &&
                                <MoreFilters
                                    anchor={'right'}
                                    filterDrawer={filterDrawer}
                                    handleFilterDrawer={handleFilterDrawer}
                                    rmpmFilters={dailyPhasingFilters.filter((filter) => !filter.label.includes('Week') && !filter.label.includes('Plan') && !filter.label.includes('UOM'))}
                                    setRmpmFilters={(filters) => {
                                        // Preserve Week, Plan, and UOM filters
                                        const weekPlanUomFilters = dailyPhasingFilters.filter(
                                            (filter) => filter.label === 'Week' || filter.label === 'Plan' || filter.label === 'UOM'
                                        );
                                        const mergedFilters = [...weekPlanUomFilters, ...filters];
                                        changeState('filters', filters);
                                        setDailyPhasingFilters(mergedFilters);
                                    }}
                                    username={activeAccount.username}
                                    type="Daily Phasing"
                                    limit = {6}
                                />
                            }
                            {excelLoading && <div className={styles.loaderExcelContainer}><CircularProgress /></div>}
                            {snackBarObject.snackbarOpen && (
                                <SnackBarMessage
                                    type={snackBarObject.type}
                                    snackbarMessage={snackBarObject.message}
                                    snackbarOpen={snackBarObject.snackbarOpen}
                                    setSnackbarOpen={closeSnackbar}
                                />
                            )}
                        </Fragment >
                    )}
                </div>
            </div >
        </>
    )
}

export default React.memo(DailyPhasingLanding);